import http from '../.././http';
// 验证码
export function getVerify(params) {
  return http.get('login/getVerify', { params, responseType: 'blob' });
}

// 第三方系统嵌入登录
export function loginByUserName(params) {
  return http.post('service-account/admin/loginWithUserName', params);
}

// 系统登录
export function postLogin(params) {
  return http.post('login/login', params);
}